const arrayOfLength = length => new Array(length).fill(1 / length)

export default arrayOfLength



// WEBPACK FOOTER //
// ./src/helpers/array-of-length.js